import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {UntypedFormControl} from '@angular/forms';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {CommonService} from '@services/common.service';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

    @Input() favorite: Favorite;
    panelColor = new UntypedFormControl('');
    constructor(
        private http: HttpClient,
        public commonService: CommonService,
    ) {
    }
    ngOnInit(): void {
        this.panelColor.setValue(this.favorite.status);
    }

    edit(event, fields = '') {
        this.http.put<any>(environment.apiUrl + 'app/favorite/' + this.favorite.id + '/status', {
            'status': this.favorite.status,
        }).subscribe(result => {
        }, error => {
        });
    }
}
